import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
// import classNames from 'classnames'
import s from './ReviewsSummary.scss';
import { Text } from 'wix-style-react';

class ReviewsSummary extends React.Component {
  static propTypes = {
    t: PropTypes.func,
    reviewScores: PropTypes.object,
  };

  render() {
    const { t, reviewScores } = this.props;

    const reviewsItems = !reviewScores.ratings
      ? null
      : reviewScores.ratings.values.map((item, index) => {
          return (
            <div className={s.reviewScoreItem} key={index}>
              <Text
                weight="bold"
                size="medium"
                secondary={false}
                light={false}
                className={s.reviewScoreLabel}
              >
                {t(`client-expertview-reviews-${item.rateType}`)}
              </Text>
              <Text
                weight="bold"
                size="medium"
                secondary={false}
                light={false}
                className={s.star}
              >
                {item.score}
              </Text>
              {index + 1 < reviewScores.ratings.values.length && (
                <span className={s.separator} />
              )}
            </div>
          );
        });

    return <div className={s.reviewsScoresSummary}>{reviewsItems}</div>;
  }
}

export default translate()(ReviewsSummary);
